<template>
  <div class="cs-signIn-courseEdit">
    <el-row class="text-center" v-if="dataIn.scope.row.StudentId > 0">
      <el-col>
        <el-row :gutter="24" class="select-sign-in-type-row select-sign-in-type-row-first">
          <el-col>
            <el-row v-if="!modelData.IsEditing">
              <el-col>
                <el-row v-if="modelData.SignInType == 0">
                  <i v-if="dataIn.isView" class="el-icon-minus icon-not-sign-color icon-make-sign"></i>
                  <i v-if="!dataIn.isView" @click="onEditIcon(modelData, dataIn.course)"
                    class="el-icon-minus icon-not-sign-color icon-make-sign  cursor-pointer"></i>
                  <span v-if="!modelData.IsDesktopSignIn">{{ modelData.SignInTimeText }}</span>
                  <span v-if="isVideoCourse" class="cs-color-frenchgrey">视频课</span>
                  <span v-if="modelData.IsVideoFree" class="cs-color-green"><br />视频免费</span>
                </el-row>

                <el-row v-if="modelData.SignInType == 1">
                  <i v-if="dataIn.isView" class="el-icon-check icon-color icon-make-sign"></i>
                  <i v-if="!dataIn.isView" @click="onEditIcon(modelData, dataIn.course)"
                    class="el-icon-check icon-color  icon-make-sign cursor-pointer"></i>
                  <span v-if="!modelData.IsDesktopSignIn">{{ modelData.SignInTimeText }}</span>
                  <span
                    :class="this.modelData.IsOffline ? 'cs-color-green' : 'cs-color-frenchgrey'">{{ isOfflineText }}</span>
                  <span v-if="isVideoCourse" class="cs-color-frenchgrey">视频课</span>
                  <span v-if="modelData.SignInSourceTypeText" class="cs-score-fair cs-signInSourceTypeText">{{ modelData.SignInSourceTypeText
                  }}</span>
                  <captureImageReview v-if="hasCaptureImage" :studentId="dataIn.scope.row.StudentId"
                    :data="dataIn.course"></captureImageReview>
                  <span v-if="modelData.IsVideoFree" class="cs-color-green"><br />视频免费</span>
                </el-row>

                <el-row v-if="modelData.SignInType == 2">
                  <span class="make-sign-late cursor-pointer" @click="onEditIcon(modelData, dataIn.course)">缺时{{
                    modelData.LateMinutes }}M</span>
                  <span v-if="!modelData.IsDesktopSignIn">{{ modelData.SignInTimeText }}</span>
                  <span
                    :class="this.modelData.IsOffline ? 'cs-color-green' : 'cs-color-frenchgrey'">{{ isOfflineText }}</span>
                  <span v-if="isVideoCourse" class="cs-color-frenchgrey">视频课</span>
                  <span v-if="modelData.SignInSourceTypeText" class="cs-score-fair cs-signInSourceTypeText">{{ modelData.SignInSourceTypeText
                  }}</span>
                  <captureImageReview v-if="hasCaptureImage" :studentId="dataIn.scope.row.StudentId"
                    :data="dataIn.course"></captureImageReview>
                  <span v-if="modelData.IsVideoFree" class="cs-color-green"><br />视频免费</span>
                </el-row>
                <el-row v-if="modelData.SignInType == 3">
                  <span v-if="!dataIn.isView" @click="onEditIcon(modelData, dataIn.course)"
                    class="make-sign-late cursor-pointer">缺课</span>
                  <span v-if="dataIn.isView" class="make-sign-late">缺课</span>
                  <span v-if="isVideoCourse" class="cs-color-frenchgrey">视频课</span>
                  <span class="cs-watchLength" v-if="hasWatchMinutes">视频观看时长 {{ getWatchMinutes() }}</span>
                  <captureImageReview v-if="hasCaptureImage" :studentId="dataIn.scope.row.StudentId"
                    :data="dataIn.course"></captureImageReview>
                  <span v-if="modelData.IsVideoFree" class="cs-color-green"><br />视频免费</span>
                </el-row>
                <el-row v-if="modelData.SignInType == 4">
                  <span v-if="!dataIn.isView" @click="onEditIcon(modelData, dataIn.course)"
                    class="make-sign-late cursor-pointer">旷课</span>
                  <span v-if="dataIn.isView" class="make-sign-late">旷课</span>
                  <span v-if="isVideoCourse" class="cs-color-frenchgrey">视频课</span>
                  <span class="cs-watchLength" v-if="hasWatchMinutes">视频观看时长 {{ getWatchMinutes() }}</span>
                  <captureImageReview v-if="hasCaptureImage" :studentId="dataIn.scope.row.StudentId"
                    :data="dataIn.course"></captureImageReview>
                  <span v-if="modelData.IsVideoFree" class="cs-color-green"><br />视频免费</span>
                </el-row>
                <el-row v-if="modelData.SignInType == 5">
                  <span class="cs-color-frenchgrey">退课</span>
                </el-row>
                <el-row v-if="modelData.SignInType == 6">
                  <i v-if="!dataIn.isView" @click="onEditIcon(modelData, dataIn.course)"
                    class="el-icon-edit icon-color-blue icon-make-sign cursor-pointer"></i>
                  <span class="cs-color-frenchgrey">视频课</span>
                  <span class="cs-watchLength" v-if="hasWatchMinutes">视频观看时长 {{ getWatchMinutes() }}</span>
                  <captureImageReview v-if="hasCaptureImage" :studentId="dataIn.scope.row.StudentId"
                    :data="dataIn.course"></captureImageReview>
                  <span v-if="modelData.IsVideoFree" class="cs-color-green"><br />视频免费</span>
                </el-row>
              </el-col>
            </el-row>
            <el-row v-if="modelData.IsEditing">
              <el-col class="clear-left-right-padding" :span="12">
                <el-select @change="onChangeSignType(modelData)" class="sign-in-type" placeholder="请选择"
                  v-model="modelData.SignInType" size="small">
                  <el-option v-for="item in signTypes" :key="item.Id" :label="item.Label" :value="item.Id">
                  </el-option>
                </el-select>
              </el-col>
              <el-col v-show="modelData.IsEditing && modelData.SignInType == 2" :span="12" class="min-input">
                <el-input maxlength="3" v-model="modelData.LateMinutes" @change="formatLateMinutes(modelData)"
                  placeholder="0min" size="small"></el-input>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="24" class="select-sign-in-type-row">
          <el-row v-if="modelData.IsEditing">
            <el-col :span="12">
              <el-checkbox class="chbxOffline" :disabled="modelData.SignInType !== 1 && modelData.SignInType !== 2"
                size="small" v-model="modelData.IsOffline" @change="onIsOfflineChange">线下签到</el-checkbox>
            </el-col>
            <el-col :span="12">
              <el-checkbox class="chbxOffline" v-if="canEditIsVideoFree" size="small" @change="onIsVideoFreeChange"
                v-model="modelData.IsVideoFree">视频免费</el-checkbox>
            </el-col>
          </el-row>
        </el-row>
        <el-row :gutter="24" class="select-sign-in-type-row">
          <el-row v-if="modelData.IsEditing">
            <el-col :span="24">
              <el-input
                @keyup.enter.native="onEditSave(dataIn.scope.row.StudentId, modelData, dataIn.course, dataIn.week.Week)"
                placeholder="请输入备注" v-model="modelData.Comment" size="small" maxlength="6" @change="onCommentChange"></el-input>
              <i @click="onEditSave(dataIn.scope.row.StudentId, modelData, dataIn.course, dataIn.week.Week)"
                class="el-icon-success icon-color btn-save-sign-in"></i>
            </el-col>
          </el-row>
          <span v-if="!modelData.IsEditing" class="sign-remark">{{ modelData.Comment }}</span>
        </el-row>
      </el-col>
    </el-row>

    <el-row class="text-center" v-if="dataIn.scope.row.StudentId < 0">
      <el-col>
        <el-row>
          <span>{{ getAttendanceCount(dataIn.scope, dataIn.course) }} / {{
            getTotalCount(dataIn.scope,
              dataIn.course)
          }}</span>
        </el-row>

        <div @click="onCourseEdit" class="cursor-pointer">
          <el-row class="course-time">
            <span>
              课时：
              <span v-if="dataIn.course.ActualStartTimeText && dataIn.course.ActualEndTimeText">
                {{dataIn.course.ActualStartTimeText}} 至 {{dataIn.course.ActualEndTimeText}}
              </span>
              ({{ dataIn.course.CourseMinutes }}分钟)
            </span>
          </el-row>

          <el-row class="course-time">
            <span>
              课间休息：
              <span v-if="dataIn.course.BreakStartTimeText && dataIn.course.BreakEndTimeText">
                {{dataIn.course.BreakStartTimeText}} 至 {{dataIn.course.BreakEndTimeText}}
              </span>
              ({{ dataIn.course.BreakMinutes }}分钟)
            </span>
          </el-row>

          <el-row class="course-time">
            <span>
              内容：{{ dataIn.course.Content }}
            </span>
            <!-- <el-tooltip v-if="!!dataIn.course.Content" class="item" effect="dark" :content="dataIn.course.Content" placement="top">
              <span>{{getCourseContentDesc(dataIn.course.Content)}}</span>
            </el-tooltip> -->
          </el-row>

          <el-row v-if="!haoJiangTaiDisabled" class="course-time">
            <span>
              视频文件：{{ dataIn.course.VideoName }}
            </span>
          </el-row>

          <el-row v-if="dataIn.course.CourseActivationType === GLOBAL.enumCourseActivationType.None" class="course-time">
            <span>
              免计签到：{{ dataIn.course.IsNotSignIn ? "是" : "否" }}
            </span>
          </el-row>

          <el-row v-if="dataIn.course.CourseActivationType === GLOBAL.enumCourseActivationType.None" class="course-time">
            <span>
              视频免费: {{ dataIn.course.IsFreeVideo ? "是" : "否" }}
            </span>
          </el-row>

          <el-row v-if="dataIn.course.CourseActivationType === GLOBAL.enumCourseActivationType.None" class="course-time">
            <span>
              类型：{{ dataIn.course.CourseCategoryText }}
            </span>
          </el-row>

          <el-row class="course-time">
            <span>
              时间戳是否一致: {{ GLOBAL.timestampStatusType.getDesc(dataIn.course.TimestampStatus) }}
            </span>
          </el-row>

          <el-row class="course-time">
            <span>
              是否开启摄像头: {{ GLOBAL.cameraStatusType.getDesc(dataIn.course.CameraStatus) }}
            </span>
          </el-row>

          <el-row class="course-time" v-if="dataIn.course.CourseActivationType === GLOBAL.enumCourseActivationType.EmailVideo">
            <span>
              有无速成元素: {{ GLOBAL.speedupElementStatusType.getDesc(dataIn.course.SpeedupElementStatus) }}
            </span>
          </el-row>
        </div>
        <el-row v-if="dataIn.course.HasVideo">
          <el-button type="primary" size="mini" @click="onVideoViewClick(dataIn.course)">视频</el-button>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<style lang="scss" scoped>
.cs-signIn-courseEdit {
  .course-time {
    color: #207cbd;
  }

  .el-table--scrollable-x .el-table__body-wrapper {
    min-height: 200px;
  }

  .cursor-pointer {
    cursor: pointer;
  }

  .sign-remark {
    color: #b4b4b4;
    font-size: 12px;
  }

  .icon-make-sign {
    font-weight: bolder;
    font-size: 18px;
  }

  .icon-not-sign-color {
    color: red;
  }

  .text-center {
    text-align: center;
  }

  .clear-left-right-padding {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }

  .select-sign-in-type-row {
    margin-top: 3px;
    padding-left: 5px;
    padding-right: 5px;

    &:last-of-type {
      margin-bottom: 0.5rem;
    }

    .chbxOffline {
      margin-bottom: 0;

      /deep/ .el-checkbox__label {
        font-size: 13px;
        padding-left: 3px;
        line-height: 17px;
      }

      /deep/ .el-checkbox__input {
        top: 1px;
      }
    }
  }

  .select-sign-in-type-row-first {
    padding-top: 10px;
    margin-top: 0;
  }

  .select-sign-in-type-row .min-input {
    padding: 0px !important;
    padding-left: 5px !important;
  }

  .el-input__inner {
    height: 20px !important;
    line-height: 20px;
    padding-left: 2px;
    padding-right: 2px;
  }

  .sign-content {
    margin-left: 20px;
  }

  .sign-title-row {
    padding-top: 8px;
  }

  .sign-table-container {
    margin-top: 30px;
  }

  .color-active {
    color: #2ab893;
  }

  .icon-color {
    color: #35b02b;
  }

  .icon-color-blue {
    color: #409EFF;
  }

  .btn-cancel-sign-in {
    color: #c1272c;
    position: absolute; //z-index: 1000;
    right: 18px;
    top: 8px;
    cursor: pointer;
  }

  .btn-save-sign-in {
    position: absolute; //z-index: 1000;
    right: 0px;
    top: 8px;
    cursor: pointer;
  }

  .header-week {
    line-height: 22px;
    padding-left: 0px;
    padding-right: 0px;
  }

  .header-merge {
    line-height: 15px;
    padding-top: 10px;
  }

  .header-not-active {
    color: #b4b4b4;
  }

  .job-icon {
    padding: 5px;
    padding-left: 7px;
    padding-right: 7px;
    cursor: default;
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .on-job-icon {
    background-color: #2ab893;
    border-color: #2ab893;
  }

  .merge-column-title {
    color: #2ab893;
  }

  .cs-watchLength {
    display: block;
  }

  .cs-signInSourceTypeText{
    font-size: 12px;
  }
}
</style>

<script>
import {
  saveStudentSignIns,
} from "../../service/signInManage.service";

import { formatMinutes } from "../../config/mUtils";
import captureImageReview from "../common/captureImageReview";
let moment = require("moment");

export default {
  components: {
    captureImageReview
  },
  props: {
    dataIn: {
      hasSignIn: Boolean,
      isView: Boolean,
      summaryEditable: Boolean,
      scope: Object,
      course: Object,
      week: Object,
      tableData: Object,
      courseCategoryList: Array
    }
  },
  data() {
    return {
      signTypes: [
        {
          Id: 1,
          Label: "正常"
        },
        {
          Id: 2,
          Label: "缺时"
        },
        {
          Id: 3,
          Label: "缺课"
        },
        {
          Id: 4,
          Label: "旷课"
        }
      ],
      modelData: {},
      IsEditing: false,
      hasCaptureImage: false,
      hasWatchMinutes: false,
      watchMinutes: false,
      isVideoCourse: false,
      haoJiangTaiDisabled: false,
      isOfflineText: "",
      canEditIsVideoFree: false,
    };
  },
  created() {
    this.haoJiangTaiDisabled = this.GLOBAL.haoJiangTaiDisabled;

    this.init();
  },
  methods: {
    onCourseEdit(){
      if (!this.dataIn.summaryEditable){
        return;
      }
      this.$emit("courseEdit", this.dataIn.course);
    },
    init() {
      this.canEditIsVideoFree = this.USERMANAGER.isAdmin || this.USERMANAGER.isExecutiveManager
        || this.USERMANAGER.isSales || this.USERMANAGER.isCampusPresident;
      this.modelData = this.getStudentSign(this.dataIn.scope, this.dataIn.course);
      this.getIsOfflineText();
      this.hasCaptureImage = false;
      if (!!this.dataIn && !!this.dataIn.scope && !!this.dataIn.scope.row && !!this.dataIn.scope.row.CaptureImageCourseActivationIdList) {
        let item = this.dataIn.scope.row.CaptureImageCourseActivationIdList.find(i => i == this.dataIn.course.CourseActivationId);
        if (!!item) {
          this.hasCaptureImage = true;
        }
      }

      this.hasWatchMinutes = false;
      if (!!this.dataIn && !!this.dataIn.scope && !!this.dataIn.scope.row && !!this.dataIn.scope.row.VAStudentWatchMinutesList) {
        let item = this.dataIn.scope.row.VAStudentWatchMinutesList.find(i => i.CourseActivationId == this.dataIn.course.CourseActivationId);
        if (!!item) {
          let minutes = item.Minutes;
          if (!!minutes && minutes > 0) {
            this.hasWatchMinutes = true;
            this.watchMinutes = minutes;
          }
        }
      }

      //init the data for summary cell
      if (this.dataIn && this.dataIn.scope && this.dataIn.scope.row && this.dataIn.scope.row.StudentId < 0
        && this.dataIn.course){
        this.courseMinutes = this.dataIn.course.CourseMinutes;
        this.breakMinutes = this.dataIn.course.BreakMinutes;
        this.actualStartTimeText = this.dataIn.course.ActualStartTimeText;
        this.actualEndTimeText = this.dataIn.course.ActualEndTimeText;
        this.breakStartTimeText = this.dataIn.course.BreakStartTimeText;
        this.breakEndTimeText = this.dataIn.course.BreakEndTimeText;
        let date = moment().format('YYYY/MM/DD');
        this.actualTime = [
          this.getDate(date, this.actualStartTimeText || "00:00"),
          this.getDate(date, this.actualEndTimeText || "23:59")
        ];
        this.breakTime = [
          this.getDate(date, this.breakStartTimeText || "00:00"),
          this.getDate(date, this.breakEndTimeText || "23:59")
        ];
      }
    },
    getDate(dateString, timeString){
      if (timeString){
        let str = `${dateString} ${timeString}`;
        return moment(str).toDate();
      }
      return null;
    },
    getWatchMinutes() {
      return formatMinutes(this.watchMinutes);
    },
    getStudentSign(scope, courseActivation) {
      var row = scope.row.SignInMgtStudentSignInList.find(
        r => r.CourseActivationId == courseActivation.CourseActivationId
      );

      if (!row) {
        this.isVideoCourse = false;
        if (!!scope.row.IsVideoFree) {
          this.isVideoCourse = true;
        } else {
          if (!!scope.row.SupplementVideoType) {
            let currentWeek = courseActivation.Week;
            let startWeek = scope.row.StartWeek;
            switch (scope.row.SupplementVideoType) {
              case 3: {
                this.isVideoCourse = true;
                break;
              }
              case 4: {
                let scourseTime = new Date(scope.row.StudentCourseStartTime);
                let activeTime = new Date(courseActivation.ActiveTime);
                if (currentWeek > startWeek || (currentWeek == startWeek && activeTime >= scourseTime)) {
                  this.isVideoCourse = true;
                }
                break;
              }
              case 5: {
                let scourseTime = new Date(scope.row.StudentCourseStartTime);
                let activeTime = new Date(courseActivation.ActiveTime);
                if (currentWeek < startWeek || (currentWeek == startWeek && activeTime <= scourseTime)) {
                  this.isVideoCourse = true;
                }
                break;
              }
            }
          }
        }

        let signIntype = 4; // 大于报名日期是旷课4
        if (courseActivation.IsActive) {
          signIntype = 0;
        } else {
          let scourseTime = new Date(scope.row.StudentCourseStartTime);
          let activeTime = new Date(courseActivation.ActiveTime);

          if (activeTime < scourseTime) {
            //小于报名日期是缺课3
            signIntype = 3;
            // if (this.isVideoCourse){
            //   signIntype = 6;
            // }
            //debugger;
          } else {
            //判断是否退课
            if (this.checkIsRefund(activeTime, scope.row)) {
              signIntype = 5;
            }

            //如果不是退课，需要判断是否视频课
            if (signIntype != 5) {
              if (this.isVideoCourse) {
                signIntype = 6;
              }
            }
          }
        }

        var addRow = {
          CourseActivationId: courseActivation.CourseActivationId,
          IsEditing: false,
          SignInType: signIntype,
          IsChanged: false,
          LateMinutes: 0,
          Comment: "",
          IsOffline: false,
          IsVideoFree: false
        };
        scope.row.SignInMgtStudentSignInList.push(addRow);

        return addRow;
      }
      return row;
    },
    checkIsRefund(activeTime, row) {
      let isRefund = false;
      if (row.HasRefund) {

        let count = row.SignInCourseList.length;
        if (row.SignInCourseList[count - 1].IsRefund) {
          let refundTime = new Date(row.SignInCourseList[count - 1].RefundTime);
          if (activeTime > refundTime) {
            isRefund = true;
          }
        }
        if (count > 1) {
          let lastRefundTime = null;

          for (let i = 0; i < count; i++) {
            let item = row.SignInCourseList[i];
            let completedTime = new Date(item.CompletedTime);
            if (!!lastRefundTime && activeTime > lastRefundTime && activeTime < completedTime) {
              isRefund = true;
              break;
            }

            if (!!item.RefundTime) {
              lastRefundTime = new Date(item.RefundTime);
            }
          }
        }
      }
      return isRefund;
    },
    onChangeSignType(row) {
      if (row.SignInType == 2) {
        if (row.LateMinutes == 0 || row.LateMinutes === "0" || row.LateMinutes == null) {
          this.$set(row, "LateMinutes", "");
        }
      }
      if (this.modelData.SignInType !== 1 && this.modelData.SignInType !== 2) {
        this.modelData.IsOffline = false;
        this.getIsOfflineText();
      }
      this.triggerChange();
    },
    onEditIcon(row, course) {
      if (this.dataIn.isView || !this.dataIn.hasSignIn){
        return;
      }
      if (!course.CourseMinutes || course.CourseMinutes <= 0) {
        this.$message({
          type: "warning",
          message: "请先录入课时分钟数"
        });
        return;
      }

      if (row.SignInType == 0 || !row.SignInType) {
        row.SignInType = 1;
      }
      if (row.SignInType >= 6) {
        row.SignInType = "";
      }

      row.IsEditing = true;
    },
    onEditSave(studentId, row, course, weekNumber) {
      if (row.SignInType == 2) {
        if (row.LateMinutes <= 0 || !row.LateMinutes) {
          this.$message({
            type: "warning",
            message: "缺时分钟数必须大于0"
          });
          return;
        }
      } else {
        this.$set(row, "LateMinutes", 0);
      }

      if (row.LateMinutes > course.CourseMinutes) {
        this.$message({
          type: "warning",
          message: "缺时分钟数不能大于课时分钟数"
        });
        return;
      }

      row.IsEditing = false;
      saveStudentSignIns(studentId, row).then(result => {
        if (!!result && result.success) {
          row.IsChanged = false;
          let id = result.data.Id;
          this.$set(row, "StudentSignInId", id);
          this.$message("保存成功！");
          this.$emit("save", weekNumber);
        }
      });
    },
    formatLateMinutes(row) {
      let intValue = parseInt(row.LateMinutes);

      if (isNaN(intValue) || intValue < 0) {
        intValue = 0;
      }

      this.$set(row, "LateMinutes", intValue);
      this.triggerChange();
    },
    getTotalCount(scope, course) {
      let videoCourseCount = 0;
      let id = course.CourseActivationId;
      this.dataIn.tableData.SignInMgtStudentList.forEach(element => {
        let signIn = element.SignInMgtStudentSignInList.filter(
          i => i.CourseActivationId == id
        );

        if (signIn && signIn.length > 0) {
          if (signIn[0].SignInType == 6) {
            videoCourseCount++;
          }
        }
      });
      return course.StudentCount - videoCourseCount;
    },
    getAttendanceCount(scope, course) {
      //debugger;
      let count = 0;
      let id = course.CourseActivationId;
      this.dataIn.tableData.SignInMgtStudentList.forEach(element => {
        let signIn = element.SignInMgtStudentSignInList.filter(
          i => i.CourseActivationId == id
        );

        if (signIn && signIn.length > 0) {
          if (signIn[0].SignInType == 1 || signIn[0].SignInType == 2) {
            count++;
          }
        }
      });
      return count;
    },
    getCourseContentDesc(content) {
      if (!!content && content.length > 20) {
        return content.substring(0, 20) + "...";
      }
      return content;
    },
    onVideoViewClick(course) {
      this.$emit("view", course);
    },
    getIsOfflineText() {
      if (this.modelData.IsOffline) {
        this.isOfflineText = "线下签到";
      } else {
        this.isOfflineText = "线上签到";
      }
    },
    onIsOfflineChange() {
      this.getIsOfflineText();
      this.triggerChange();
    },
    onCommentChange(){
      this.triggerChange();
    },
    onIsVideoFreeChange(){
      this.triggerChange();
    },
    triggerChange(){
      this.modelData.IsChanged = true;
      this.$emit("dataChange");
    }
  },
  watch: {
    dataIn: function () {
      this.init();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/signInManage/signInMangeEditCourse.vue